import script from "./followRemind.vue?vue&type=script&setup=true&lang=js"
export * from "./followRemind.vue?vue&type=script&setup=true&lang=js"

import "./followRemind.vue?vue&type=style&index=0&id=ff9ee7f2&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff9ee7f2"]])

export default __exports__